import PropTypes from 'prop-types'

const videoShape = {
  id: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  slug: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  vimeoVideoId: PropTypes.number,
  position: PropTypes.number,
  discretion: PropTypes.bool,
  discretionText: PropTypes.string,
  levels: PropTypes.string,
  clbLevels: PropTypes.string,
  cefrLevels: PropTypes.string,
  eldLevels: PropTypes.string,
  audiences: PropTypes.string,
  grades: PropTypes.string,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      taggings_count: PropTypes.number,
    })
  ),
  category: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    slug: PropTypes.string,
  }),
  genre: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    slug: PropTypes.string,
  }),
}

export const LessonShape = {
  id: PropTypes.number,
  type: PropTypes.string,
  title: PropTypes.string,
  lesson_section_id: PropTypes.number,
  lesson_section_title: PropTypes.string,
  level_display: PropTypes.string,
  teacher_discretion: PropTypes.bool,
  path: PropTypes.string,
  thumbnail_url: PropTypes.string,
}

export const VideoDataShape = {
  ...videoShape,
  playlist: PropTypes.arrayOf(PropTypes.shape(videoShape)),
  lessons: PropTypes.arrayOf(PropTypes.shape(LessonShape)),
}
